<template>
  <div v-if="_messages.length > 0">
    <div
      v-for="message in _messages"
      :key="message"
      class="api-status-banner"
      role="alert"
    >
      <span class="mdi mdi-alert-outline" />
      {{ message }}
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref, watch} from "vue";
import {useRoute} from "vue-router";
import {storeToRefs} from "pinia";
import {useAccountStore} from "@/stores/accountStore";
import {ApiApiStatus} from "@/shared/services/apiStatus";

const _route = useRoute()
const {authenticated} = storeToRefs(useAccountStore())

const _messages = ref<string[]>([])

async function load() {
  if (!authenticated.value) {
    _messages.value = []
    return
  }
  const status = await new ApiApiStatus().load()
  const messages: string[] = []
  if (status?.purchaseBlocked && status.purchaseMessage) {
    messages.push(status.purchaseMessage)
  }
  if (status?.evbGenerationBlocked && status.evbGenerationMessage) {
    messages.push(status.evbGenerationMessage)
  }
  _messages.value = [...new Set(messages)]
}

// beim Anmelden und bei jedem Seitenwechsel neu laden, damit Änderungen in der Config ohne Reload sichtbar werden
watch([authenticated, () => _route.fullPath], load, {immediate: true})
</script>

<style scoped>
.api-status-banner {
  margin: 8px;
  padding: 10px 14px;
  border-radius: 4px;
  border: 1px solid #f0ad4e;
  background-color: #fff3cd;
  color: #664d03;
}
</style>
